export default "__VITE_ASSET__Ciwayr$6__"